import { combineReducers } from "redux";
import normalizedReducers from "../utils/normalized/reducers";
import { ModelType } from "./model";

function meta(state = { authenticated: false, semiAuthScope: null }, action) {
  state = normalizedReducers.metaReducer(ModelType, state, action);
  switch (action.type) {
    case `UPDATE_${ModelType}`:
    case `CREATE_${ModelType}`:
      return {
        activeId: action.payload.id,
        authenticated: true,
        semiAuthScope: state.semiAuthScope,
      };
    case `REMOVE_${ModelType}`:
      return {
        ...state,
        authenticated: false,
        semiAuthScope: null,
      };
    case "SET_SEMI_AUTH_SCOPE":
      return {
        ...state,
        semiAuthScope: action.payload,
      };
    case "CLEAR_SEMI_AUTH_SCOPE":
      return {
        ...state,
        semiAuthScope: null,
      };
    default:
      return state;
  }
}

function byId(state = {}, action) {
  return normalizedReducers.byIdReducer(ModelType, state, action);
}

function allIds(state = [], action) {
  return normalizedReducers.allIdsReducer(ModelType, state, action);
}

export default combineReducers({ meta, byId, allIds });
